import React from 'react'
import '../stylings/footer.css'
import { Link } from 'react-router-dom'
import { IoIosMail, IoLogoWhatsapp } from 'react-icons/io'
import { FaFacebook, FaLocationDot, FaYoutube } from 'react-icons/fa6'
import { TbBrandInstagramFilled } from 'react-icons/tb'
import logo from '../assest/logo_footer.png'
import { MdCall } from 'react-icons/md'


const Footer = () => {
    return (
        <div className="box-container footer">

            <div class="custom-shape-divider-bottom-1739780868">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" class="shape-fill"></path>
                </svg>
            </div>
            <div className="footer-wrapper">
                <div className="footer-details-wrapper">

                    <div className="details">
                        <div className="img-container">
                            <img src={logo} alt="" />
                        </div>
                        <div className="body small-size">
                            <p>Way, Truth and Life Foundation School has widespread interest in the sphere of the quality education with the commitment to nurture the uniqueness of our students and enabling young minds.!</p>
                        </div>
                        <div className="svg-container">
                            <Link to={'https://wa.me/8595015369'} target='_blank'><IoLogoWhatsapp /></Link>
                            <Link to={'https://www.facebook.com/share/A9jp8wy2G8JHEgKS/?mibextid=qi2Omg'} target='_blank'><FaFacebook /></Link>
                            <Link><FaYoutube /></Link>
                            <Link to={'https://www.instagram.com/wtl_foundation?igsh=enZoM2xscjRqZ3Nl'} target='_blank'><TbBrandInstagramFilled /></Link>
                        </div>
                    </div>

                    <div className="details align-items-center">
                        <div className="details-heading">
                            <p>Quick Links</p>
                        </div>
                        <ul className='small-size'>
                            <Link to={'/'}><li>Home</li></Link>
                            <Link to={'about-school'}><li>About Us</li></Link>
                            <Link><li>What We Offer</li></Link>
                            <Link><li>Admission</li></Link>
                            <Link to={'contact'}><li>Contact Us</li></Link>
                        </ul>
                    </div>

                    <div className="details px-3">

                        <div className="info-wrapper">
                            <div className="svg-container">
                                <MdCall />
                            </div>
                            <div className="body">
                                <p>Call Us</p>
                                <p className='small-size'>+91-8595015369</p>
                            </div>
                        </div>

                        <div className="info-wrapper">
                            <div className="svg-container">
                                <IoIosMail />
                            </div>
                            <div className="body">
                                <p>Mail Us</p>
                                <p className='small-size'>wtlfoundation91@gmail.com</p>
                            </div>
                        </div>

                        <div className="info-wrapper">
                            <div className="svg-container">
                                <FaLocationDot />
                            </div>
                            <div className="body">
                                <p>Location</p>
                                <p className='small-size'>Phase 6, Aya Nagar Delhi - 110047</p>
                            </div>
                        </div>

                    </div>
                </div>
                {/* <LineSeperator /> */}
                <div className="copyright small-size">
                    <p className='copyright-info'>&copy; Copyright 2025, all rights reserved with Way, Truth and Life Foundation School</p>
                    <div className="designed-detail">
                        <p>Designed and Developed By: <Link to="http://www.mycampus.co.in/" target="_blank"
                            rel="noopener noreferrer">myCampus Technology</Link></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
